import { ServiceResult } from '../models';
import {
  CreateRecipeDetailRequest,
  CreateRecipeDetailsRequest,
  DeleteRecipeDetailRequest,
  RecipeDetail,
  RecipeDetailHeader,
  SequenceRecipeDetailsRequest,
  UpdateRecipeDetailRequest,
} from '../models/recipe-detail.models';
import ApiService from './api-service';

class RecipeDetailService extends ApiService {
  private static classInstance: RecipeDetailService;

  private constructor() {
    super('RecipeDetail');
  }

  public static getInstance(): RecipeDetailService {
    if (!this.classInstance) {
      this.classInstance = new RecipeDetailService();
    }
    return this.classInstance;
  }

  public getRecipeDetail(recipeDetailId: string, customerId: string): ServiceResult<RecipeDetail> {
    return this.get(`${this.baseUrl}/GetRecipeDetail?recipeDetailId=${recipeDetailId}&customerId=${customerId}`);
  }

  public getRecipeDetails(
    recipeHeaderId: string,
    customerId: string,
    servingsScaled?: number
  ): ServiceResult<RecipeDetail[]> {
    var servingsParams = servingsScaled != undefined ? `&servingsScaled=${servingsScaled}` : '';
    return this.get(
      `${this.baseUrl}/GetRecipeDetails?recipeHeaderId=${recipeHeaderId}&customerId=${customerId}${servingsParams}`
    );
  }

  public createRecipeDetail(request: CreateRecipeDetailRequest): ServiceResult<RecipeDetail> {
    return this.post(`${this.baseUrl}/CreateRecipeDetail`, request);
  }

  public createRecipeDetails(request: CreateRecipeDetailsRequest): ServiceResult<RecipeDetail[]> {
    return this.post(`${this.baseUrl}/CreateRecipeDetails`, request);
  }

  public updateRecipeDetail(request: UpdateRecipeDetailRequest): ServiceResult<RecipeDetail> {
    return this.post(`${this.baseUrl}/UpdateRecipeDetail`, request);
  }

  public deleteRecipeDetail(request: DeleteRecipeDetailRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeDetail`, request);
  }

  public sequenceRecipeDetails(request: SequenceRecipeDetailsRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/SequenceRecipeDetails`, request);
  }

  public getRecipeDetailHeadersByIngredient(
    customerId: string,
    ingredientId: string
  ): ServiceResult<RecipeDetailHeader[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeDetailHeadersByIngredient?customerId=${customerId}&ingredientHeaderId=${ingredientId}`
    );
  }

  public getRecipeDetailHeadersBySubRecipe(
    customerId: string,
    subRecipeHeaderId: string
  ): ServiceResult<RecipeDetailHeader[]> {
    return this.get(
      `${this.baseUrl}/getRecipeDetailHeadersBySubRecipe?customerId=${customerId}&subRecipeHeaderId=${subRecipeHeaderId}`
    );
  }
}

export default RecipeDetailService;
